import { PostMethod } from '../../serviceHelper';

const getMethods = (service: 'workflow', controller: 'UserStartup') => ({
	EditLanguage: new PostMethod<any, any>({
		service,
		controller,
		method: 'EditLanguage'
	}),
	EditNotificationSoundStatus: new PostMethod<any, any>({
		service,
		controller,
		method: 'EditNotificationSoundStatus'
	}),
	EditLocation: new PostMethod<any, any>({
		service,
		controller,
		method: 'EditLocation'
	}),
	EditCulture: new PostMethod<any, any>({
		service,
		controller,
		method: 'EditCulture'
	})
});

export { getMethods };
